import React, { FC } from "react";
import { IconType } from "./types";

export const SideMenuRightIcon: FC<IconType> = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.33341 18.3333H0.666748V1.66666H2.33341V18.3333Z"
      fill="white"
      fill-opacity="0.6"
    />
    <path
      d="M5.16667 10.8333L15.3083 10.8333L10.65 15.4917L11.8333 16.6667L18.5 9.99999L11.8333 3.33332L10.6583 4.50832L15.3083 9.16666L5.16667 9.16666L5.16667 10.8333Z"
      fill="white"
    />
  </svg>
);
